export const checkLocalStorageAccess = (suppressErrors = false) => {
  let localStorageOK = false;
  try {
    const pattern = `test if we can write some data to localStorage${'0'.repeat(8192)}`;
    localStorage.setItem('check', pattern);
    const check = localStorage.getItem('check');
    if (check === pattern) {
      localStorage.removeItem('check');
      localStorageOK = true;
    }
  } catch (error) {
    if (!suppressErrors) {
      assert(false, error);
    }
    // Storage calls throw DOMException.
    if (
      (error as DOMException).code === 22 ||
      (error as DOMException).name === 'NS_ERROR_FILE_CORRUPTED' ||
      (error as DOMException).name === 'QuotaExceededError'
    ) {
      // QuotaExceededError / File error: Corrupted
      try {
        localStorage.clear();
        localStorageOK = true;
      } catch (serviceError) {
        assert(false, serviceError);
      }
    }
  }

  return localStorageOK;
};
